// extracted by mini-css-extract-plugin
export default {"main_div":"AdressInfoDiv_main_div__E20NQ","addressDiv":"AdressInfoDiv_addressDiv__+UStz","textUnderline":"AdressInfoDiv_textUnderline__+HoFx"};